import { unflatten } from 'flat'

import {
  Warehouse,
  WarehouseApi,
  WarehouseFormData,
  WarehouseFormDataApi,
  WarehouseFormErrors,
  WarehouseFormErrorsApi,
  WarehouseSelect,
  WarehouseSelectApi,
} from '../types'
import { formDataFlat } from '@shared/utils/form-data-flat'

export class WarehouseMappers {
  public static fromApi(department: WarehouseApi): Warehouse {
    return {
      id: department.id,
      name: department.warehouse_name,
      code: department.warehouse_code,
      descr: department.descr,
      isMain: !!department.is_main,
      address: department.address,
      department: {
        id: department.department?.id ?? '',
        name: department.department?.department_name ?? '',
        descr: department.department?.descr ?? null,
      },
      state: {
        id: department.state?.id ?? '',
        name: department.state?.state_name ?? '',
        descr: department.state?.descr ?? null,
      },
      createdAt: department.created_at,
      updatedAt: department.updated_at,
    }
  }

  public static manyFromApi(raw: WarehouseApi[]): Warehouse[] {
    return raw.map((item) => this.fromApi(item))
  }

  public static fromSelectApi(select: WarehouseSelectApi): WarehouseSelect {
    return {
      id: select.id,
      name: select.warehouse_name,
      code: select.warehouse_code,
      departmentId: select.department_id,
      isMain: !!select.is_main,
    }
  }

  public static manyFromSelectApi(raw: WarehouseSelectApi[]): WarehouseSelect[] {
    return raw.map((item) => this.fromSelectApi(item))
  }

  public static formDataToApi(formData: WarehouseFormData): WarehouseFormDataApi {
    return formDataFlat({
      id: formData.id,
      warehouse_name: formData.warehouseName,
      warehouse_code: formData.warehouseCode,
      department_id: formData.departmentId,
      is_main: !!formData.isMain ? 1 : 0,
      address: formData.address,
      state_id: formData.stateId,
      descr: formData.descr,
    })
  }

  public static formErrorsFromApi(errors: WarehouseFormErrorsApi): WarehouseFormErrors {
    const unFlatten: Record<string, string[]> = unflatten(errors)

    return {
      id: unFlatten.id?.join(', '),
      isMain: unFlatten.is_main?.join(', '),
      warehouseName: unFlatten.warehouse_name?.join(', '),
      warehouseCode: unFlatten.warehouse_code?.join(', '),
      departmentId: unFlatten.department_id?.join(', '),
      address: unFlatten.address?.join(', '),
      stateId: unFlatten.state_id?.join(', '),
      descr: unFlatten.descr?.join(', '),
    }
  }

  public static formInitializer(department: Warehouse): WarehouseFormData {
    return {
      id: department.id.toString(),
      isMain: department.isMain,
      warehouseName: department.name,
      warehouseCode: department.code,
      departmentId: department.department?.id?.toString() ?? '',
      stateId: department.state?.id?.toString() ?? '',
      address: department.address,
      descr: department.department?.descr ?? null,
    }
  }
}
